<template>
    <section class="dark" @click="closeProductTc">
        <section class="product-box" @click.stop>
            <header>
                <img src="~static/img/search-gray.png" alt="icon" />
                <input type="text" name="" placeholder="请输入产品名称或美团产品编号" v-model="searchInput" />
                <input type="button" value="搜索" @click="getProductList(1, true)" />
            </header>
            <table v-loading="loading">
                <thead>
                    <tr>
                        <th width="15%">产品编号</th>
                        <th>产品名称</th>
                        <th>美团评价</th>
                        <th width="10%">产品状态</th>
                        <th width="10%">操作</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in productData.data" :key="item.dealId">
                        <td>{{ item.dealId }}</td>
                        <td>{{ item.dealName }}</td>
                        <td><span v-if="item.mtReviewCount !== 0">{{ item.mtScore }}分 {{ item.mtReviewCount }}条评价</span><span class="span-gray" v-else>暂无评价</span></td>
                        <td>{{ item.onlineStatus | formatOnlineStatus }}</td>
                        <td><router-link :to="{ name: businessTypeName + 'reviewDetail', params: { type: businessTypeName, id: item.dealId, name: item.dealName } }" v-if="item.mtReviewCount !== 0 && did != item.dealId">查看</router-link><span class="span-gray" v-else>查看</span></td>
                    </tr>
                </tbody>
            </table>
            <v-pagination
                :current='currentPage'
                :total='Math.ceil(productData.totalCount / 10)'
                :size="'md'"
                :first="false"
                :last="false"
                v-on:current-change="currentChangeFunc($event)"
            ></v-pagination>
        </section>
    </section>
</template>

<style lang="postcss">
    :root {
        --blueColor: #2A99F1;
    }
    .dark {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: flex;
        align-items: flex-start;
        justify-content: center;
        & .product-box {
            margin-top:40px;
            width: 85%;
            padding: 30px;
            background-color: #FFF;
            border-radius: 2px;
            overflow-x: hidden;
            overflow-y: auto;
            & > header {
                width: 100%;
                height: 42px;
                border-bottom: 1px solid #F2F3F8;
                padding-bottom: 12px;
                & > input[type="text"] {
                    display: inline-block;
                    width: 70%;
                    height: 100%;
                    border: 0;
                    &::-webkit-input-placeholder {
                        color: #989AA5;
                    }
                }
                & > input[type="button"] {
                    width: 68px;
                    height: 100%;
                    float: right;
                    border: 0;
                    color: #FFF;
                    background-color: var(--blueColor);
                    border-radius: 2px;
                }
            }
            & > table {
                width: 100%;
                margin-top: 16px;
                & tr {
                    height: 40px;
                    & th {
                        border: 1px solid #DFE2E5;
                        background-color: #F7F9FA;
                        text-align: left;
                        padding: 0 2%;
                    }
                    & td {
                        border: 1px solid #DFE2E5;
                        padding: 0 2%;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        & > a {
                            color: var(--blueColor);
                        }
                        & > .span-gray {
                            color: #8F9192;
                        }
                    }
                }
            }
            & > div {
                text-align: right;
                & .pagination {
                    & li {
                        &.active span {
                            background-color: var(--blueColor);
                            border-color: var(--blueColor);
                        }
                        & a {
                            color: var(--blueColor);
                        }
                    }
                }
            }
        }
    }
</style>

<script>
    import Comment from 'api/comment'

    export default {
        data () {
            return {
                loading: false, // 表格加载
                searchInput: '', // 搜索内容
                productData: {
                    data: [],
                    totalCount: 0
                },
                currentPage: 1
            }
        },
        props: ['did', 'businessType', 'businessTypeName'],
        methods: {
            // 关闭弹层
            closeProductTc: function () {
                this.$emit('closeProductTc')
            },

            // 获取产品列表
            getProductList (page = 1, isSearch = false) {
                if (isSearch) {
                    this.currentPage = 1
                }
                this.loading = true
                Comment.getProductList(this.businessType, this.searchInput, page)
                    .then((res) => {
                        this.productData.data = res.data
                        this.productData.totalCount = res.totalCount
                        this.loading = false
                    })
                    .catch((err) => {
                        this.loading = false
                        console.log(err)
                        this.$notify.error({
                            title: '错误',
                            message: err.message || '出错了，请稍后再试'
                        })
                    })
            },

            // 切换页码
            currentChangeFunc: function (data) {
                this.currentPage = data.current
                this.getProductList(this.currentPage)
            }
        },
        filters: {
            // 格式化在线状态
            formatOnlineStatus (status) {
                let str = ''
                switch (status) {
                    case 1: str = '已上线'
                        break
                    case 0: str = '未上线'
                        break
                    default: str = '未知'
                }
                return str
            }
        },
        created () {
            this.getProductList()
        }
    }
</script>



// WEBPACK FOOTER //
// Product.vue?e7e4452a